import styled from '@emotion/styled';
import { css, Grid, Theme, Typography } from '@mui/material';
import { colors } from 'theme/colors';

interface IStyledFormElementWrapper {
  disabled?: boolean;
  fullWidth?: boolean;
  oneLine?: boolean;
}
export const StyledFormElementWrapper = styled.div<IStyledFormElementWrapper>`
  display: flex;
  ${(props: IStyledFormElementWrapper) =>
    props.oneLine
      ? css`
          gap: 24px;
        `
      : css`
          flex-direction: column;
        `}
  ${(props: IStyledFormElementWrapper) =>
    props.fullWidth &&
    css`
      width: 100%;
    `}
  ${(props: IStyledFormElementWrapper) =>
    props.disabled &&
    css`
      .MuiOutlinedInput-root {
        background: ${colors.gray100} !important;
      }
      input {
        padding: 15px 14px;
        font-size: 16px;
        color: ${colors.gray400};
        background: ${colors.gray100} !important;
      }
    `}
`;

export const StyledPageTitle = styled(Typography)`
  color: ${colors.primary400};
  text-transform: capitalize;
  margin-bottom: 8px;
  white-space: nowrap;
  width: 100%;
  ${({ theme }) => `
      ${(theme as Theme).breakpoints.down('md')} {
        & {
            white-space: normal;
          };
        };
        `};
`;

export const StyledPageSubTitle = styled(Typography)`
  color: ${colors.primary500};
  letter-spacing: 0.02em;
  font-weight: 600;
`;

export const StyledSearchForm = styled(Grid)`
  margin-top: 0px;
  row-gap: 0px;
  & .MuiGrid-item {
    padding-top: 0px;
  }
`;

export const StyledForm = styled(Grid)`
  & .MuiGrid-item {
    padding-top: 0px;
  }
`;
